import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import OrangeEnterprisesLogo from "../../images/OrangeEnterprisesLogo.jpg";
import * as actions from "../../actions";
import { GoogleLogin } from "react-google-login";
import { GOOGLE_CLIENT_ID } from "../../config";

function parseGoogleResponse(response) {
  const { profileObj, accessToken } = response;
  if(profileObj){
    const { imageUrl, email, name } = profileObj;

    return {
      accessToken,
      profile: { email, name, userImage: imageUrl },
    }
  }
  return {
    accessToken
  };
}

class Header extends Component {
  constructor(props) {
    super(props);
    this.signOut = this.signOut.bind(this);
  }
  signOut() {
    this.props.signOut();
  }
  
  responseGoogle = (response) => {
    const {
      signinWithGoogle
    } = this.props
    const parsedData = parseGoogleResponse(response);
    if (parsedData.accessToken) {
      signinWithGoogle(parsedData);
    }
  }

  render() {
   const { isAuthenticated, fullName } = this.props.authentication;
    return (
      <nav className="navbar navbar-expand-lg bg-dark fixed-top">
        <Link className="navbar-brand mr-0" to="/">
          <img
            src={OrangeEnterprisesLogo}
            alt="Logo"
            style={{ width: "40px" }}
          />
          <span className={"ml-1"} style={{ color: "#e77b00" }}>
            Orange
          </span>
        </Link>
        {isAuthenticated ? (
          <button
            type="button"
            id="sidebarCollapse"
            className="btn bg-transparent px-0"
            onClick={this.props.toggleSideBar}
          >
            <i className="fas fa-align-left text-white"></i>
          </button>
        ) : null}
        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="nav navbar-nav ml-auto">
            {!isAuthenticated
              ? [
                <li className="nav-item" key="signin">
                <GoogleLogin
                clientId={GOOGLE_CLIENT_ID}
                buttonText="Login with Google"
                onSuccess={this.responseGoogle}
                onFailure={this.responseGoogle}
                      cookiePolicy={"single_host_origin"}
              />
                  </li>,
                ]
              : null}

            {isAuthenticated
              ? [
                  <li className="nav-item" key={"Item1"}>
                    <span className="text-white mr-4 mb-0">
                      {" "}
                      <i className="far fa-user text-white"></i>
                      {fullName}
                    </span>
                  </li>,
                  <li className="nav-item" key={"Item2"}>
                    <Link
                      className="text-white py-1"
                      to="/"
                      onClick={this.signOut}
                    >
                      Sign Out
                    </Link>
                  </li>,
                ]
              : null}
          </ul>
        </div>
      </nav>
    );
  }
}

function mapStateToProps(state) {
  return {
    authentication: state.auth,
  };
}

export default connect(mapStateToProps, actions)(Header);
